<div class="closing-x-wrap">
    <mat-icon (click)="close()" class="close-icon">close</mat-icon>
</div>
<h1 mat-dialog-title>{{ data.videoTitle }}</h1>
<div mat-dialog-content>
    <video controls autoplay width="100%" height="100%" controls>
        <source [src]="data.videoSource" type="video/mp4" />
    </video>
</div>
